module.exports = __webpack_public_path__ + "static/media/avatar-3.d14f61d5.jpg";